/** @format */

import React, { useState, useEffect, useRef, useCallback } from "react";
// import pdfjs from "@bundled-es-modules/pdfjs-dist/build/pdf";
import { useSelector, useDispatch } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { pdfCoordinates } from "../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import PageModificationUtils from "../Pdf-Utils/PageModification";
import { Chip, Stack, Divider, Box, Typography, Button } from "@mui/material";
import { pdfDetails } from "../../../store/reducers/pdfeditor/pdfDetailsSlice"; 
import { pdfPreviousDetails } from "../../../store/reducers/pdfeditor/previousDataSlice";
import styled from "styled-components";
import { apiEndpoint } from "../../../urls"; 
import BoxLayout from "../CoordinateFields/BoxLayout";
import { useMemo } from "react";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import InsertPdf from "../Pdf-Utils/InsertPdf";
import { addPdfData } from "../../../store/reducers/pdfeditor/insertPdfSlice";
import { createCanvas, getAddedPdf } from "../../../Helpers";
import { addPage, deletePage } from "../../../store/reducers/pdfeditor/pageModificationSlice";
import "../../../App.css";
// import { getDocument } from "@bundled-es-modules/pdfjs-dist/build/pdf";
// import { getDocument } from "pdfjs-dist";
// import { throttle } from "lodash";
import throttle from "lodash/throttle";
// import { toggleSingleClick } from "../../../store/PdfEditor/singleClickSlice";

import * as pdfjs from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker?url"; // Import local worker
import { esignIcons } from "../../Esign/icons";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
let scale = 1.5;

const PdfViewer = ({ containerRef, pdfPagesRef, pdfPages, setPdfPages }) => {
  const [showCustomCursor, setShowCustomCursor] = useState(true);
  const { setOpenSideBar, openSideBar } = useOutletContext();
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const { uploadedDocument } = useSelector((state) => state.uploadDocument);
  const { signers } = useSelector((state) => state.signers);
  const [showOverlayPages, setShowOverlayPages] = useState([]);
  const [overlayPosition, setOverlayPosition] = useState({});

  const { fontSize, currBoxSize } = useSelector(
    (state) => state.toolsModification || []
  );
  console.log("uploadedDocument",uploadedDocument)
  // Shape states start
  const [currentPage, setCurrentPage] = useState(1);
  const thumbnailsRef = useRef([]);
  const canvasRefs = useRef([]);

  const [currentShape, setCurrentShape] = useState(null); // State to manage the current shape
  const [shapes, setShapes] = useState([]); // State to store drawn shapes
  
  // Shape states end

  const {
    dragToggleButton,
    textToggleButton,
    eraseToggleButton,
    imageToggleButton,
    shapeToggleButton,
  } = useSelector((state) => state.toolsModification || []);
  console.log(
    "toolsmodification data",
    textToggleButton,
    eraseToggleButton,
    imageToggleButton,
    shapeToggleButton
  );
  // console.log('before dispatching the data1', textToggleButton);
  const textToggleButtonRef = useRef(textToggleButton);
  useEffect(() => {
    textToggleButtonRef.current = textToggleButton;
  }, [textToggleButton]);

  const eraserToggleButtonRef = useRef();
  useEffect(() => {
    eraserToggleButtonRef.current = eraseToggleButton;
  }, [eraseToggleButton]);

  const shapeToggleButtonRef = useRef();
  useEffect(() => {
    shapeToggleButtonRef.current = shapeToggleButton;
  }, [shapeToggleButton]);

  const imageToggleButtonRef = useRef(imageToggleButton);
  useEffect(() => {
    imageToggleButtonRef.current = imageToggleButton;
  }, [imageToggleButton]);

  const currBoxSizeRef = useRef(null);

  const handleMouseMove = useCallback(
    throttle((e) => {
      const cursorContainer = document.getElementById("cursor-container");
      const rect = cursorContainer?.getBoundingClientRect();
      const x = e?.clientX - rect?.left;
      const y = e?.clientY - rect?.top;
      setPosition({ x, y });
    }, 5),
    []
  );
  const [isDrawing, setIsDrawing] = useState(false);
  const [startPoint, setStartPoint] = useState({ x: 0, y: 0 });
  // Start drawing shape
  const startDrawingShape = (e, pageIndex) => {
    console.log("started shape drawing....");
    setIsDrawing(true);
    setStartPoint({ x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY });
  };

  // Continue drawing the shape
  const continueDrawingShape = (e, pageIndex) => {
    if (!isDrawing) return;
    console.log("continueDrawingShape shape drawing....");
    const canvas = canvasRefs.current[pageIndex];
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
    ctx.beginPath();

    const x = e.nativeEvent.offsetX;
    const y = e.nativeEvent.offsetY;
    ctx.rect(startPoint.x, startPoint.y, x - startPoint.x, y - startPoint.y); // Draw the rectangle
    ctx.stroke();
  };

  // Finish drawing the shape
  const finishDrawingShape = (e, pageIndex) => {
    setIsDrawing(false);
    console.log("finishDrawingShape shape drawing....");
    const canvas = canvasRefs.current[pageIndex];
    const ctx = canvas.getContext("2d");

    const shape = {
      type: "rectangle",
      startX: startPoint.x,
      startY: startPoint.y,
      width: e.nativeEvent.offsetX - startPoint.x,
      height: e.nativeEvent.offsetY - startPoint.y,
    };

    ctx.rect(shape.startX, shape.startY, shape.width, shape.height); // Finalize drawing the rectangle
    ctx.stroke();
  };

  useEffect(() => {
    if (!uploadedDocument) return;
    setLoader(false);
    let multiPage =
      uploadedDocument?.other_actions?.multiple_pages?.insert || null;
    // dispatch(insertPdf(multiPage));
    let modifyData = getAddedPdf(multiPage);
    if (modifyData) {
      dispatch(addPdfData(modifyData));
    }
    let url = `${apiEndpoint.pdfBaseUri}${uploadedDocument?.data?.document_url}`;
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.arrayBuffer();
      })
      .then((data) => {
        renderPdf(data);
      });
  }, [uploadedDocument]);

  /* 🔧 PATCH #1 — Auto convert backend px → ratio */
useEffect(() => {
  if (!uploadedDocument?.coordinates) return;
  if (!pdfPages || pdfPages.length === 0) return;

  const converted = uploadedDocument.coordinates.map((coord) => {
    const pageIndex = coord.pageNumber;        // 0-based
    const canvas = pdfPages[pageIndex]?.canvas;
    if (!canvas) return coord;

    const pageW = canvas.width;
    const pageH = canvas.height;

    return {
      ...coord,
      xRatio: (coord["x-coordinate"]) / pageW,
      yRatio: (coord["y-coordinate"]) / pageH,
      widthRatio: (coord.width) / pageW,
      heightRatio: (coord.height) / pageH,
    };
  });

  converted.forEach((c) => dispatch(pdfCoordinates(c)));
}, [uploadedDocument, pdfPages]);


  useEffect(() => {
    let removeCanvas = pdfPages?.map(({ canvas, ...rest }) => rest);
    dispatch(pdfDetails(removeCanvas));
    // dispatch(pdfPreviousDetails(removeCanvas))
  }, [pdfPages]);


  useEffect(() => {
    if (!pdfPages) return;
  
    const generateThumbnails = () => {
      pdfPages.forEach((page, index) => {
        const scaleFactor = 3; // Increase for higher resolution
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        const targetWidth = 176 * scaleFactor; // Adjust based on displayed size
        const targetHeight = (page.canvas.height / page.canvas.width) * targetWidth;
  
        canvas.width = targetWidth;
        canvas.height = targetHeight;
  
        ctx.drawImage(page.canvas, 0, 0, canvas.width, canvas.height);
        
        // Store high-quality image
        thumbnailsRef.current[index] = canvas.toDataURL("image/png", 1.0);
      });
    };
  
    generateThumbnails();
  }, [pdfPages]);
  

  const handleThumbnailClick = (index) => {
    setCurrentPage(index + 1);
    const pageElement = document.querySelector(`[data-page-index="${index}"]`);
    if (pageElement) {
      pageElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      clearTimeout(scrollTimeout);

      if (!scrollTimeout) {
        setShowCustomCursor(false);
      }

      scrollTimeout = setTimeout(() => {
        setShowCustomCursor(true);
        scrollTimeout = null;
      }, 500);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);

      clearTimeout(scrollTimeout);
    };
  }, []);

  // const handleMouseMove = useCallback(
  //   throttle((e) => {
  //     const cursorContainer = document.getElementById("cursor-container");
  //     const rect = cursorContainer?.getBoundingClientRect();
  //     const x = e?.clientX - rect?.left;
  //     const y = e?.clientY - rect?.top;
  //     setPosition({ x, y });
  //   }, 5),
  //   []
  // );

  // functionality for the shapes start
  const handleShapeStart = (e) => {
    // Function to handle the start of shape drawing
    const rect = e.target.getBoundingClientRect();
    const x = (e.clientX - rect.left) / scale;
    const y = (e.clientY - rect.top) / scale;

    setCurrentShape({
      type: "rect", // You can change this to the selected shape type
      startX: x,
      startY: y,
      endX: x,
      endY: y,
    });
  };

  const handleShapeMove = (e) => {
    // Function to handle shape drawing on mouse move
    if (!currentShape) return;

    const rect = e.target.getBoundingClientRect();
    const x = (e.clientX - rect.left) / scale;
    const y = (e.clientY - rect.top) / scale;

    setCurrentShape((prevShape) => ({
      ...prevShape,
      endX: x,
      endY: y,
    }));
  };

  const handleShapeEnd = () => {
    // Function to handle the end of shape drawing
    if (!currentShape) return;

    setShapes((prevShapes) => [...prevShapes, currentShape]);
    setCurrentShape(null);
  };

  useEffect(() => {
    const handleMouseUp = () => handleShapeEnd();
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [currentShape]);
  // functionality for the shapes end

  const renderPdf = async (data) => {
    try {
      setLoader(true);
      let canvasPages = await createCanvas(data, scale);
      console.log("data we get in renderpdf is", data);

      // Insert page or delete page ==>
      let addedBlankPage = uploadedDocument?.other_actions?.single_page;
      if (addedBlankPage && Object.keys(addedBlankPage).length > 0) {
        const updatedPdfPages = [...canvasPages];
        Object.keys(addedBlankPage).forEach((item) => {
          if (addedBlankPage[item].insert) {
            dispatch(addPage(parseInt(item)));
            const existingCanvas = canvasPages[0]?.canvas;
            const existingWidth = existingCanvas?.width;
            const existingHeight = existingCanvas?.height;
            const newCanvas = document.createElement("canvas");
            newCanvas.width = existingWidth;
            newCanvas.height = existingHeight;
            updatedPdfPages.splice(item - 1, 0, {
              canvas: newCanvas,
              addedPage: true,
              inserted: false,
              id: `page-${canvasPages?.length + 1}`,
            });
          } else {
            updatedPdfPages.splice(item - 1, 1);
            dispatch(deletePage(parseInt(item)));
          }
        });
        setPdfPages(updatedPdfPages);
      } else {
        setPdfPages(canvasPages);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
      toast.error(
        "Apologies, it seems the PDF file is corrupted. Please try again with a valid PDF file."
      );
    }
  };

  useEffect(() => {
    currBoxSizeRef.current = { ...currBoxSize, fontSize };
  }, [currBoxSize, fontSize]);

  const handleClick = (event, index) => {
    if (signers.length > 0) {
      const rect = event.target.getBoundingClientRect();
      let x = event.clientX - rect.left;
      let y = event.clientY - rect.top;

      const boxWidth = currBoxSizeRef.current?.width || 0;
      const boxHeight = currBoxSizeRef.current?.height || 0;
      const gap = 2; // 2px gap from edges

      // Clamp values with a 2px gap
      x = Math.max(gap, Math.min(x, rect.width - boxWidth - gap));
      y = Math.max(gap, Math.min(y, rect.height - boxHeight - gap));

      const data = {
        id: Date.now(),
        pageNumber: index,
        "x-coordinate": x / scale,
        "y-coordinate": y / scale,
        addTextBox: textToggleButtonRef.current,
        eraserBox: eraserToggleButtonRef.current,
        height: boxHeight,
        width: boxWidth,
        xRatio: x / rect.width,
        yRatio: y / rect.height,
        widthRatio: boxWidth / rect.width,
        heightRatio: boxHeight / rect.height,
        ...(eraserToggleButtonRef.current && { value: "eraseVal" }),
        ...(textToggleButtonRef.current && { boldVal: false }),
        ...(textToggleButtonRef.current && { italicVal: false }),
        ...(textToggleButtonRef.current && { fontFamily: "Georgia" }),
        ...(textToggleButtonRef.current && { fontSize: 10 }),
        addImageBox: imageToggleButtonRef.current,
        ...(imageToggleButtonRef.current && { value: "imageVal" }),
        ...(imageToggleButtonRef.current && { imageUrl: "" }),
        shapeBox: shapeToggleButtonRef.current ? true : false,
        ...(shapeToggleButtonRef.current && {
          shape: shapeToggleButtonRef.current,
          thickness: 2,
          color: "rgba(0, 0, 0, 1)",
          fill: false,
          fillColor: "rgba(0,0,0,1)",
          radius: shapeToggleButtonRef.current === "circle" ? "50%" : "0",
          rotation: 0,
          value: "shapeVal",
        }),
      };

      dispatch(pdfCoordinates(data));
    }
  };



  const style = {
    position: "relative",
    width: "fit-content",
    Padding: "0 20px",
    borderRight: "1px solid #ccc",
    scrollbarWidth: "thin",
    scrollbarColor: "#ccc #f4f4f4",
    // border:'30px solid lightgrey'
  };

  // Main
  const renderedPdfPages = useMemo(() => {
    return pdfPages?.map((canvas, index) => {
      const showOverlay =
        (!signers || signers.length === 0) && showOverlayPages[index];
  
      return (
        <div
          key={`page-${index}`}
          style={style}
          onMouseEnter={() => {if (!showOverlay) setShowCustomCursor(true); else setShowCustomCursor(false)}}
          onMouseLeave={() => setShowCustomCursor(false)}
          data-page-index={index}
          className="pdf-page"
          ref={(ref) => (pdfPagesRef.current[index] = ref)}
          onClick={(e) => {
            if (!signers || signers.length === 0) {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left; // relative X
              const y = e.clientY - rect.top;  // relative Y
          
              setShowOverlayPages((prev) => {
                const updated = [...prev];
                updated[index] = true;
                return updated;
              });
          
              setOverlayPosition((prev) => ({
                ...prev,
                [index]: { x, y },
              }));
            }
          }}          
        >
          <div
            onMouseLeave={() => {if (!showOverlay) setShowCustomCursor(true); else setShowCustomCursor(false)}}
            onMouseEnter={() => setShowCustomCursor(false)}
            style={chipStyle}
          >
            <Chip label={index + 1} variant="outlined" />
          </div>
  
          <Box sx={{ position: "relative", width: "100%" }}>
            <img
              onMouseMove={handleMouseMove}
              id="cursor-container"
              style={{
                border: "1px solid #ccc",
                userSelect: "none",
                height: canvas.canvas.height,
                width: canvas.canvas.width,
              }}
              src={canvas.canvas.toDataURL()}
              alt={`Page ${index}`}
              loading="lazy"
              onClick={(e) => handleClick(e, index + 1)}
            />
  
            {showOverlay && (
              <Box
                className="overlay"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "99%",
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                  transition: "opacity 0.3s ease-in-out",
                  zIndex: 10,
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: overlayPosition[index]?.y || "50%",   // cursor Y
                    left: overlayPosition[index]?.x || "50%", // cursor X
                    transform: "translate(-50%, -100%)", // adjust position above cursor
                    width: 257,
                    height: 40,
                    background: "#FFFFFF",
                    pl: "16px",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#185CB7",
                    }}
                  >
                    You have to add signer first.
                  </Typography>
                  <Button
                    sx={{ minWidth: 40, p: 0, m: 0 }}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering parent click
                      setShowOverlayPages((prev) => {
                        const updated = [...prev];
                        updated[index] = false;
                        return updated;
                      });
                    }}
                  >
                    {esignIcons.crossIcon}
                  </Button>
                </Box>
              </Box>
            )}

          </Box>
  
          <Divider sx={{ color: "blue", pb: 1 }}>
            <Stack direction="row" alignItems="center" spacing={2}></Stack>
          </Divider>
  
          <BoxLayout
            setShowCustomCursor={setShowCustomCursor}
            pageIndex={index + 1}
            scale={scale}
            dimensions={{
              width: canvas?.["canvas"]?.width,
              height: canvas?.["canvas"]?.height,
            }}
          />
        </div>
      );
    });
  }, [pdfPages, signers, showOverlayPages]);
  

  let cursorStyle = {
    left: position.x,
    top: position.y,
    position: "absolute",
    width: `${currBoxSize?.width}px`,
    height: `${currBoxSize?.height}px`,
    border: "2px solid #ccc",
    zIndex: 99,
    transition: `all 0s ease`,
    PointerEvent: "none",
    display: !showCustomCursor ? "none" : "block",
  };


  useEffect(() => {
    if (!pdfPages || !Array.isArray(pdfPages)) return;
    if (!thumbnailsRef.current) thumbnailsRef.current = [];
  
    if (pdfPages.length > 0 && thumbnailsRef.current.length === pdfPages.length) {
      setLoader(false);
    }
  }, [pdfPages, thumbnailsRef.current]);
  
  
  if (loader) {
    return <Loader show={true} />;
  }

  return (
    <div style={{ display: "flex" }}>
      {/* <div style={{ width: "194px", height: "100%", overflow: "hidden auto", marginRight: openSideBar ? "2em" : "4em", padding: "8px 8px" }}>
        {thumbnailsRef.current.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Page ${index + 1}`}
            style={{
              width: "176px",
              height: "207px",
              margin: "5px",
              cursor: "pointer",
              border: currentPage === index + 1 ? "3px solid #185CB7" : "2px solid #D9D9D9",
              borderRadius: 12,

            }}
            onClick={() => handleThumbnailClick(index)}
          />
        ))}
      </div> */}
      <div ref={containerRef} style={{ position: "relative", marginTop: "10px", overflow: "auto", flex: 1 }}>
        {renderedPdfPages}
        <div
          className="custom-cursor"
          style={{ ...cursorStyle, pointerEvents: "none" }}
        />
      </div>
    </div>
  );
};

export default PdfViewer;

const chipStyle = {
  position: "absolute",
  bottom: "7%",
  left: "47%",
};

